import { render, staticRenderFns } from "./InterestFollowupRuleDialog.vue?vue&type=template&id=4c5b2fc8&scoped=true&"
import script from "./InterestFollowupRuleDialog.vue?vue&type=script&lang=js&"
export * from "./InterestFollowupRuleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b2fc8",
  null
  
)

export default component.exports